import { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import { apiSendCOIToBroker } from 'api';

interface UseResendToBrokerOptions {
  uuid: string | undefined;
  successMessage: string;
}

export const useResendToBroker = ({
  uuid,
  successMessage,
}: UseResendToBrokerOptions) => {
  const toast = useToast();
  const [isResending, setIsResending] = useState(false);

  const handleResendToBroker = async () => {
    if (!uuid) return;

    setIsResending(true);
    try {
      await apiSendCOIToBroker(uuid);
      toast({
        title: 'Success',
        description: successMessage,
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (error: any) {
      toast({
        title: 'Error',
        description: error?.response?.data?.error || 'Failed to send to broker',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsResending(false);
    }
  };

  return {
    handleResendToBroker,
    isResending,
  };
};
